import React from 'react'
import { Link } from 'react-router-dom';

import './Pagination.css'


const Pagination = () =>{
    return (

        <>
        <div className="pagination">
            <ul className="pagination-list d-flex">
                <li className="list-items li-1">
                 <Link to="">1</Link>
                </li>
                <hr className='line' />
                <li className="list-items li-2">
                <Link to="">2</Link>
                </li>
                <hr  className='line'/>
                <li className="list-items li-3">
                <Link to="">3</Link>
                </li>
            </ul>
        </div>
        </>
    )
}
export default Pagination;